module.exports = __webpack_public_path__ + "static/img/can-coconut-pineapple.bb28087.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-coconut-pineapple.png
// module id = /Yg3
// module chunks = 0